module.exports = __webpack_public_path__ + "static/media/wavm8s-028-space-candy.f65574a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-028-space-candy.mp3
// module id = OgQ9
// module chunks = 0